import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";

import {
  defaultSort,
  vsObjectName as gamingContractName,
} from "./gamingContract";

export const vsObjectName = "gamingContractFeeStructure";

const url = "api/contract/gamingContract/feeStructure";

FeeStructureConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function FeeStructureConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  configureColumnDefinitionSets(columnDefinitionSetServiceProvider);
  configureGrid(recordGridViewServiceProvider);
}

function configureColumnDefinitionSets(
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    ColumnDefinitionServiceName,
    (
      columnDefinitionSetService: ColumnDefinitionSetService,
      columnDefinitionService: ColumnDefinitionService
    ) => [
      columnDefinitionService.getStringColDef({
        field: "GamingContractFeeStructureTypeName",
        header: "Fee Structure Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "FeeStructureDetails",
        header: "Fee Structure Details",
      }),
      ...columnDefinitionSetService.getColumnDefinitionSet(gamingContractName),
    ],
  ]);
}
function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ): GridConfiguration => {
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: `${defaultSort},Id`,
        nameSingular: "Fee Structure",
        namePlural: "Fee Structures",
        gridDataSource: new RecordDataSource(serverUtility, url),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
      };
    },
  ]);
}
